export type Genre = {
  key: string;
  name: string;
  icon: string;
};

export const genres: Genre[] = [
  { key: 'action', name: '动作', icon: 'ri-sword-line' },
  { key: 'comedy', name: '喜剧', icon: 'ri-emotion-happy-line' },
  { key: 'scifi', name: '科幻', icon: 'ri-planet-line' },
  { key: 'romance', name: '爱情', icon: 'ri-heart-3-line' },
  { key: 'animation', name: '动画', icon: 'ri-palette-line' },
  { key: 'thriller', name: '悬疑', icon: 'ri-spy-line' },
  { key: 'drama', name: '剧情', icon: 'ri-film-line' },
  { key: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
];

export const genreNameMap: Record<string, string> = {
  action: '动作',
  comedy: '喜剧',
  scifi: '科幻',
  romance: '爱情',
  animation: '动画',
  thriller: '悬疑',
  drama: '剧情',
  horror: '恐怖',
};